import React from "react";

function Send() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="21"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 176.368 176.368"
    >
      <path
        fill="#fff"
        d="M175.865 12.489c2.469-7.408-4.578-14.456-11.986-11.987L6.48 52.969c-8.839 2.946-8.565 15.542.393 18.101l76.552 21.873 21.872 76.552c2.56 8.959 15.155 9.233 18.101.393zm-12.34 7.055l-49.116 147.348-21.83-76.403zm-6.701-6.701L85.879 83.788 9.477 61.959z"
        clipRule="evenodd"
        data-original="#000000"
      ></path>
    </svg>
  );
}

export default Send;
